<template>
	<ui-modal-template>
		<template v-slot:title>
			{{ __("Edit freight rate") }}
		</template>

		<template v-slot:content>
			<ui-form class="h-full flex flex-col" :loading="loading" @submit="submitForm">
				<div class="px-6 py-4">
					<p class="text-sm text-gray-500 mb-4">
						{{ __("Distance up to") }}:
						<span class="font-semibold text-gray-900">{{ row.distance_up_to }} km</span>
					</p>

					<ui-input-group
						v-model="form.cost_per_ton"
						field="cost_per_ton"
						label="Cost per ton (€/t)"
						:form="form"
						:required="true"
					/>
				</div>

				<div class="flex flex-col-reverse sm:flex-row justify-end gap-y-3 gap-x-3 px-6 pb-6">
					<ui-button
						type="secondary"
						class="w-full sm:w-auto"
						@click="$bus.$emit('modal:close')"
					>{{ __("Cancel") }}</ui-button>

					<ui-button
						type="primary"
						class="w-full sm:w-auto"
						:disabled="loading"
						@click="submitForm"
					>{{ __("Save") }}</ui-button>
				</div>
			</ui-form>
		</template>
	</ui-modal-template>
</template>

<script>
import axios from "axios";

export default {
	props: {
		row: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			loading: false,
			form: Vue.observable({
				errors: {},
				hasErrors: false,
				clearErrors() {},
				cost_per_ton: this.row.cost_per_ton,
			}),
		};
	},

	methods: {
		/**
		 * @return {void}
		 */
		async submitForm() {
			this.loading = true;

			try {
				await axios.patch(
					this.$route("admin.freight_rates.update", { id: this.row.id }),
					{ cost_per_ton: this.form.cost_per_ton }
				);

				this.$bus.$emit("modal:close");
				this.$bus.$emit("content:load");
				this.$bus.$emit("toast", { type: "success", message: this.__("Freight rate updated.") });
			} catch (error) {
				if (error.response?.status === 422) {
					this.$bus.$emit("form:invalid", error.response.data.errors);
				} else {
					this.$bus.$emit("modal:error", error);
				}
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
